



























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import WorkItemSummary from '@/domain/work-item/work-item-summary.entity';
import VstsIntegrationBlockedIcon from './vsts-integration-blocked-icon.component.vue';
import Items from '@/views/work-item/items.json';
import WorkItemType from '@/domain/work-item/work-item-type.entity';

@Component({
  components: {
    VstsIntegrationBlockedIcon,
  },
})
export default class WorkItemsRow extends Vue {
  @Prop({ type: WorkItemSummary, required: true }) workItem!: WorkItemSummary;

  @Prop({ type: Array }) headerOptions!: any[];

  @Prop({ type: Boolean, default: false }) expanded!: boolean;

  @Prop({ type: Boolean, default: false }) expandable!: boolean;

  @Prop({ type: String, default: '#FFFFFF' }) backgroundColor!: string;

  @Prop({ type: Array, default: () => [] }) selectedWorkItens!: WorkItemSummary[];

  @Prop({ type: Boolean, default: false }) expandedWorkItemStatusDone!: boolean;

  @Prop({ type: Boolean, default: false })
  allowMandalaEditClosedVsts!: boolean;

  items: any[] = Items;

  get itemsTranslated() {
    return this.items.map(item => ({
      value: item.value,
      label: this.$t(item.label),
    }));
  }

  get isCheckboxDisabled(): boolean {
    const alreadySelected = this.selectedWorkItens.some(item => item.id === this.workItem.id);
    return (!alreadySelected && this.selectedWorkItens.length >= 100)
      || this.expandedWorkItemStatusDone || this.workItem.originSystem !== 'CORE';
  }

  expand(): void {
    this.$emit('expand');
  }

  displayColumn(columnName: string): boolean {
    const column: any = this.headerOptions.find(
      (header: any) => header.value === columnName,
    );
    return column.active;
  }

  disableButtons(status: string, origin: string): boolean {
    if (status === 'OPEN' && origin === 'CORE') {
      return false;
    }

    return true;
  }

  viewModal(event: any): void {
    event.stopPropagation();
    this.$emit('view', this.workItem.id);
  }

  editModal(event: any): void {
    event.stopPropagation();
    if (this.workItem.status !== 'DELETED' && this.workItem.status !== 'DONE') {
      this.$emit('edit', this.workItem.id);
      return;
    }
    this.$emit('reactivate', this.workItem.id);
  }

  deleteItem(event: any): void {
    event.stopPropagation();
    this.$emit('delete', this.workItem.id);
  }

  closeItem(event: any): void {
    event.stopPropagation();
    this.$emit('close', this.workItem.id);
  }

  closeTaskItem(event: any): void {
    event.stopPropagation();
    this.$emit('closeTask', this.workItem.id);
  }

  get lineBackgroundStyle(): string {
    return `background-color: ${this.backgroundColor}`;
  }

  addNewTask(value: boolean): void {
    this.$emit('showModalNewTaskWithAggregator', this.workItem, value);
  }

  getStatusColor(status: string): string {
    const statusColors: Record<string, string> = {
      OPEN: '#4492DB',
      DELETED: '#6C6C6C',
      CANCELED: '#B20106',
      DONE: '#3FAF28',
    };

    return statusColors[status] || '#000000';
  }

  onSelect(checked: boolean) {
    let newSelected = [...this.selectedWorkItens];
    if (checked) {
      if (!newSelected.some(item => item.id === this.workItem.id)) {
        newSelected.push(this.workItem);
      }
    } else {
      newSelected = newSelected.filter(item => item.id !== this.workItem.id);
    }
    this.$emit('update:selectedWorkItens', newSelected);
  }

  get disableEditButton(): boolean {
    const isVsts = this.workItem.originSystem === 'VSTS';
    const isOpen = this.workItem.status === 'OPEN';
    const isClosed = this.workItem.status === 'DONE';

    if (this.workItem.vstsIntegrationBlocked) {
      return false;
    }

    if (isVsts && isOpen) {
      return true;
    }
    if (isVsts && isClosed && this.allowMandalaEditClosedVsts) {
      return false;
    }
    if (isVsts && isClosed && !this.allowMandalaEditClosedVsts) {
      return true;
    }
    return false;
  }
}
